/* =====================================================================
   ALL THINGS PALESTINE  |  Motion engine (v2)
   Vanilla JS, no libraries. Safe by default: if anything fails, content
   stays visible. Honors prefers-reduced-motion and the theme editor.
   ===================================================================== */
(function () {
  'use strict';

  var d = document, html = d.documentElement, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var motion = html.classList.contains('atp-motion');

  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function raf(fn) { return (w.requestAnimationFrame || setTimeout)(fn); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function easeOutExpo(t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); }

  /* ------------------------------------------------------------------
     1. Auto-tag theme elements so every section animates, not just ours
     ------------------------------------------------------------------ */
  var AUTO = [
    { sel: 'main .shopify-section .section-header', type: 'up' },
    { sel: 'main .shopify-section .section-footer', type: 'up' },
    { sel: 'main .shopify-section .grid__item', type: 'up', group: true },
    { sel: 'main .shopify-section .multicolumn-grid-item', type: 'up', group: true },
    { sel: 'main .main-collection-banner, main .collection-hero', type: 'fade' },
    { sel: 'main .product-main-info-section > *', type: 'up', group: true, cap: 10 },
    { sel: 'main .product-media-component', type: 'fade' },
    { sel: 'main .rte > *', type: 'up', group: true, cap: 8 },
    { sel: 'main .main-page-title, main .page-title, main h1.title', type: 'up' },
    { sel: '.shopify-section-group-footer-group .footer-block-column', type: 'up', group: true },
    { sel: '.shopify-section-group-footer-group .footer-shopping-info-column, .shopify-section-group-footer-group .footer-shopping-info .grid__item', type: 'up', group: true }
  ];

  function tag(root, initial) {
    var vh = w.innerHeight;
    AUTO.forEach(function (rule) {
      $$(rule.sel, root).forEach(function (el) {
        if (el.hasAttribute('data-atp-reveal') || el.hasAttribute('data-atp-skip') || el.closest('[data-atp-own]') || el.closest('.header-group, cart-drawer, .quick-add-modal, dialog, [role="dialog"]')) return;
        if (el.classList.contains('button')) return;
        if (initial) {
          // Already on screen at first paint: leave it alone so nothing flickers
          var r = el.getBoundingClientRect();
          if (r.top < vh * 0.94 && r.bottom > 0) { el.setAttribute('data-atp-skip', ''); return; }
        }
        el.setAttribute('data-atp-reveal', rule.type);
        if (rule.group && el.parentElement) {
          var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(rule.sel); });
          var i = sibs.indexOf(el);
          el.style.setProperty('--atp-i', Math.min(i, rule.cap || 6));
        }
      });
    });
    // Cascading indexes for menus and cart lines
    $$('.header-nav-drawer-linklist > li', root).forEach(function (li, i) { li.style.setProperty('--atp-i', Math.min(i, 12)); });
  }

  /* ------------------------------------------------------------------
     2. Reveal on scroll (IntersectionObserver, once)
     ------------------------------------------------------------------ */
  var io = null;
  function done(el) {
    el.classList.add('is-inview');
    setTimeout(function () { el.classList.add('atp-done'); }, 1900);
  }
  function observe(root) {
    var els = $$('[data-atp-reveal]:not(.is-inview), [data-atp-count], .atp-draw', root);
    if (!motion || !('IntersectionObserver' in w)) { els.forEach(done); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          io.unobserve(el);
          // Items inside a horizontal carousel reveal together with their row
          var slider = el.closest('.slider-element, .slider-grid');
          if (slider && !slider.__atpShown) {
            slider.__atpShown = true;
            $$('[data-atp-reveal]', slider).forEach(function (x) { io.unobserve(x); done(x); });
          }
          if (el.hasAttribute('data-atp-count')) countUp(el);
          done(el);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     3. Count-up numbers (keeps the original formatting at the end)
     ------------------------------------------------------------------ */
  function countUp(el) {
    if (el.__atpCounted) return; el.__atpCounted = true;
    el.__atpCounting = true;
    var finalText = el.textContent;
    var target = parseFloat(finalText.replace(/[^0-9.]/g, ''));
    if (!target || reduce) { el.__atpCounting = false; return; }
    var prefix = finalText.match(/^[^0-9]*/)[0], suffix = finalText.match(/[^0-9.,]*$/)[0];
    var dur = 1900 + Math.min(900, target / 20), t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = clamp((ts - t0) / dur, 0, 1), v = Math.round(target * easeOutExpo(p));
      el.textContent = prefix + v.toLocaleString('en-US') + suffix;
      if (p < 1) raf(step); else { el.textContent = finalText; el.__atpCounting = false; if (el.__atpPending) { var q = el.__atpPending; el.__atpPending = null; setLive(el, q); } }
    }
    el.textContent = prefix + '0' + suffix;
    raf(step);
  }

  /* ------------------------------------------------------------------
     4. Scroll-driven effects: progress bar, smart header, parallax,
        back-to-top, marquee speed boost. One rAF loop, passive listeners.
     ------------------------------------------------------------------ */
  var progress, topBtn, lastY = w.pageYOffset, ticking = false, velocity = 0, parallaxEls = [], marquees = [];

  function buildChrome() {
    // top scroll progress bar removed at the owner's request

    topBtn = d.createElement('button');
    topBtn.type = 'button'; topBtn.className = 'atp-top'; topBtn.setAttribute('aria-label', 'Back to top');
    topBtn.innerHTML = '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="22"/></svg><i aria-hidden="true">&uarr;</i>';
    topBtn.addEventListener('click', function () { w.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    d.body.appendChild(topBtn);
  }

  function locked() {
    var b = d.body;
    return b.classList.contains('body-lock-scroll') || b.classList.contains('overflow-hidden') ||
      !!d.querySelector('cart-drawer.active, .header-nav-drawer.open, .header-nav-desktop-dd-panel.active, details[open].menu-opening') ||
      (d.activeElement && d.activeElement.closest && !!d.activeElement.closest('.header-group'));
  }

  function onFrame() {
    ticking = false;
    var y = w.pageYOffset, max = Math.max(1, d.documentElement.scrollHeight - w.innerHeight), dy = y - lastY;
    velocity = velocity * 0.8 + Math.abs(dy) * 0.2;
    var p = clamp(y / max, 0, 1);
    html.style.setProperty('--atp-p', p.toFixed(4));
    html.classList.toggle('atp-scrolled', y > 12);
    if (topBtn) topBtn.classList.toggle('is-on', y > 900);

    if (!locked()) {
      if (y > 220 && dy > 6) html.classList.add('atp-hdr-hide');
      else if (dy < -6 || y < 160) html.classList.remove('atp-hdr-hide');
    } else {
      html.classList.remove('atp-hdr-hide');
    }

    if (motion) {
      var vh = w.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var speed = parseFloat(el.getAttribute('data-atp-parallax')) || 0.12;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      var boost = 1 + clamp(velocity / 14, 0, 3.5);
      marquees.forEach(function (m) { if (m.getAnimations) m.getAnimations().forEach(function (a) { a.playbackRate = boost; }); });
    }
    lastY = y;
  }
  function requestFrame() { if (!ticking) { ticking = true; raf(onFrame); } }

  // Let the marquee settle back to cruise speed after a fast scroll
  function settleLoop() {
    velocity *= 0.9;
    if (motion && marquees.length) {
      var boost = 1 + clamp(velocity / 14, 0, 3.5);
      marquees.forEach(function (m) { if (m.getAnimations) m.getAnimations().forEach(function (a) { a.playbackRate = boost; }); });
    }
    setTimeout(settleLoop, 120);
  }

  /* ------------------------------------------------------------------
     5. Magnetic buttons (desktop mouse only)
     ------------------------------------------------------------------ */
  function magnetic(root) {
    if (!fine || !motion) return;
    $$('.button, .atp-magnetic', root).forEach(function (b) {
      if (b.__atpMag || b.closest('cart-drawer, .quick-add-modal, .shopify-payment-button')) return;
      b.__atpMag = true;
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width, yv = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate3d(' + (x * 10).toFixed(1) + 'px,' + (yv * 8).toFixed(1) + 'px,0)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ------------------------------------------------------------------
     6. Image loading shimmer on product cards
     ------------------------------------------------------------------ */
  function shimmer(root) {
    $$('.card-product--image-wrapper img, .card-product--image img', root).forEach(function (img) {
      if (img.__atpShim || img.complete) return;
      img.__atpShim = true;
      var box = img.closest('.card-product--image-wrapper') || img.parentElement;
      box.classList.add('atp-loading');
      var off = function () { box.classList.remove('atp-loading'); };
      img.addEventListener('load', off, { once: true });
      img.addEventListener('error', off, { once: true });
      setTimeout(off, 5000);
    });
  }

  /* ------------------------------------------------------------------
     7. Add to cart: image flies to the bag, bag bounces, button confirms
     ------------------------------------------------------------------ */
  var lastForm = null;
  d.addEventListener('submit', function (e) {
    var pf = e.target && e.target.closest && e.target.closest('product-form');
    if (pf) lastForm = pf;
  }, true);

  function cartIcon() {
    return $$('.hdr-st-item-cart').filter(function (el) { return el.offsetParent !== null; })[0] || d.querySelector('.hdr-st-item-cart');
  }

  function flyToCart(form) {
    var icon = cartIcon();
    if (!form || !icon || reduce) return;
    var scope = form.closest('.quick-add-modal, .main-product--section, .shopify-section, section') || d;
    var img = $$('img', scope).filter(function (i) { var r = i.getBoundingClientRect(); return r.width > 60 && r.bottom > 0 && r.top < w.innerHeight; })[0];
    if (!img) return;
    var a = img.getBoundingClientRect(), b = icon.getBoundingClientRect();
    var size = Math.min(140, a.width);
    var fly = d.createElement('div');
    fly.className = 'atp-fly';
    fly.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
    var clone = new Image(); clone.src = img.currentSrc || img.src; clone.alt = '';
    fly.appendChild(clone); d.body.appendChild(fly);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    if (!fly.animate) { fly.remove(); return; }
    var anim = fly.animate([
      { transform: 'translate3d(0,0,0) scale(1)', opacity: 1, borderRadius: '14px' },
      { transform: 'translate3d(' + dx * 0.45 + 'px,' + (dy * 0.45 - 90) + 'px,0) scale(.6)', opacity: 1, offset: 0.55 },
      { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(.12)', opacity: .2, borderRadius: '50%' }
    ], { duration: 850, easing: 'cubic-bezier(.65,0,.35,1)' });
    anim.onfinish = function () { fly.remove(); bump(); };
  }

  function bump() {
    $$('.hdr-st-item-cart, .hdr-cart-count, .cart-icon--bubble').forEach(function (el) {
      el.classList.remove('atp-bump'); void el.offsetWidth; el.classList.add('atp-bump');
    });
  }

  function hookCart() {
    try {
      /* global subscribe, PUB_SUB_EVENTS */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
          if (!evt || evt.source !== 'product-form') { bump(); return; }
          var form = lastForm;
          // olive tree planting moment (atp-plant.js); falls back to the classic fly-to-cart
          if (!(w.atpPlant && w.atpPlant(form, bump))) flyToCart(form);
          var btn = form && form.querySelector('button[type="submit"], [name="add"]');
          if (btn) {
            btn.classList.add('atp-atc-success');
            setTimeout(function () { btn.classList.remove('atp-atc-success'); }, 1600);
          }
          if (reduce) bump();
        });
      }
    } catch (err) { /* cart animations are optional */ }
  }

  /* ------------------------------------------------------------------
     8. Cart drawer lines cascade each time it opens
     ------------------------------------------------------------------ */
  function indexCartLines() {
    $$('cart-drawer .cart-item').forEach(function (li, i) { li.style.setProperty('--atp-i', Math.min(i, 8)); });
  }


  /* ------------------------------------------------------------------
     Live impact numbers: re-read the order count every 30 seconds and
     roll the numbers up when new orders come in. No page refresh needed.
     ------------------------------------------------------------------ */
  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
  function setLive(el, target) {
    if (el.__atpCounting) { el.__atpPending = target; return; }
    var current = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (isNaN(current) || current === target) return;
    if (reduce || target < current) { el.textContent = fmt(target); return; }
    var from = current, t0 = null, dur = 1400;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = clamp((ts - t0) / dur, 0, 1);
      el.textContent = fmt(from + (target - from) * easeOutExpo(p));
      if (p < 1) raf(step);
    }
    raf(step);
    el.classList.remove('atp-live-bump'); void el.offsetWidth; el.classList.add('atp-live-bump');
  }
  function pollLive() {
    if (!d.querySelector('[data-atp-live]') || !w.fetch) return;
    var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
    var busy = false;
    function tick() {
      if (busy || d.visibilityState === 'hidden') return;
      busy = true;
      fetch(root + '?section_id=atp-live-counts&atp=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = /id="atp-live-counts"[^>]*>([\s\S]*?)<\/script>/.exec(html || '');
          if (!m) return;
          var data = JSON.parse(m[1]);
          $$('[data-atp-live]').forEach(function (el) {
            var v = parseInt(data[el.getAttribute('data-atp-live')], 10);
            if (!isNaN(v)) setLive(el, v);
          });
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    setInterval(tick, 30000);
    d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'visible') tick(); });
  }

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */
  function scan(root, initial) {
    try { tag(root, initial); } catch (e) {}
    observe(root);
    magnetic(root);
    shimmer(root);
    parallaxEls = motion ? $$('[data-atp-parallax]') : [];
    marquees = $$('.atp-marquee__track');
  }

  function boot() {
    w.__atpBooted = true;
    buildChrome();
    scan(d, true);
    hookCart();
    indexCartLines();
    pollLive();
    w.addEventListener('scroll', requestFrame, { passive: true });
    w.addEventListener('resize', requestFrame, { passive: true });
    onFrame();
    settleLoop();

    // Safety net: never leave anything hidden
    setTimeout(function () {
      $$('[data-atp-reveal]:not(.is-inview)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < w.innerHeight && r.bottom > 0) done(el);
      });
    }, 2500);

    // Re-run when the cart drawer re-renders or new products load (filters, pagination, quick view)
    if ('MutationObserver' in w) {
      var pending = null;
      new MutationObserver(function (muts) {
        var relevant = muts.some(function (m) { return m.addedNodes && m.addedNodes.length; });
        if (!relevant) return;
        clearTimeout(pending);
        pending = setTimeout(function () { scan(d); indexCartLines(); }, 120);
      }).observe(d.querySelector('main') || d.body, { childList: true, subtree: true });
      var drawer = d.querySelector('cart-drawer');
      if (drawer) new MutationObserver(indexCartLines).observe(drawer, { childList: true, subtree: true });
    }
  }

  // Theme editor support
  d.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
